// src/hooks/useSendQrCodeByEmail.js
import QRCodeStyling from "qr-code-styling";
import generateQrCodeOptions from "../utils/generateQrCodeOptions";
import { v4 as uuidv4 } from 'uuid';

const useSendQrCodeByEmail = (qrCode, data, type, options, appSiteUrl, appApiUrl, endPointSendEmailQrCode) => {
    const handleSendEmail = async (resolution, email, downloadExtension) => {
        if (!qrCode) return;

        const qrCodeDownload = new QRCodeStyling({
            width: resolution,
            height: resolution,
            ...generateQrCodeOptions(data, type, options, appSiteUrl)
        });

        const blob = await qrCodeDownload.getRawData(downloadExtension);
        const uuid = uuidv4();
        const fileName = `qrcbr.com.br-${uuid.slice(0, 4)}.${downloadExtension}`;
        const formData = new FormData();
        formData.append('email', email);
        formData.append('file', new File([blob], fileName, { type: `image/${downloadExtension}` }));
        await fetch(`${appApiUrl}/${endPointSendEmailQrCode}`, {
            method: 'POST',
            body: formData
        });
    };

    return { handleSendEmail };
};

export default useSendQrCodeByEmail;